import styled, { css } from 'styled-components';

export const StyledWrapper = styled.div<{ isImage: boolean; isAudio: boolean; isVideo: boolean }>`
    position: relative;
    ${({ isImage }) => isImage && 'cursor: zoom-in;'};

    ${({ isVideo, isAudio }) =>
        (isVideo || isAudio) &&
        css`
            cursor: pointer;
        `};
`;

export const VideoWrapper = styled.div`
    position: relative;
    padding-bottom: 100%;
    height: 0;
`;

export const VideoInnerWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;
